"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StepOneFileItem = function StepOneFileItem(_ref) {
  var file = _ref.file,
    validFiletype = _ref.validFiletype,
    differentFilename = _ref.differentFilename;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "file_list_slide_override",
    key: file.file.name
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "fileSection",
    className: "file_title_list override_list",
    style: {
      display: validFiletype ? "none" : "",
      color: "black"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    title: file ? file.file.name : null,
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      width: "auto",
      maxWidth: "40%",
      fontWeight: differentFilename ? "500" : "400"
    }
  }, file.file.name)), differentFilename ? /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    title: "This file's name does not match, uploading will override the current version but keep the original file's name",
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "ep:warning-filled",
    height: 15,
    style: {
      display: validFiletype ? "none" : "",
      color: "black",
      marginLeft: "5px"
    },
    "aria-label": "Warning: ".concat(file.file.name, " will override existing file")
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)));
};
var _default = exports["default"] = StepOneFileItem;